/**
 * Blurb content wrapper for text content.
 */
export default function BlurbContent({ children, className = '' }) {
  if (!children) return null;

  return <div className={`Blurb__content ${className}`}>{children}</div>;
}
